import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import './DisputeRejectModal.css';
import closeIcon from '../../../../../assets/Admin/RequestImages/close-icon.svg';
import rejectIcon from '../../../../../assets/Admin/RequestImages/reject-icon.svg';
import { toast } from 'react-hot-toast';
// import { useNavigate } from 'react-router-dom'
// import { axiosInstance } from '../../../../../utils/tokenUtils'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const DisputeRejectModal = ({
  setRejectOpen,
  onReject,
  userRole = 'student',
  isReport = false,
}) => {
  // const navigate = useNavigate();

  const handleClose = () => {
    setRejectOpen(false);
  };
  const handleReject = async () => {
    try {
      await onReject(''); // Passing empty string as comment
      toast.success(isReport ? 'Report denied successfully' : 'Dispute denied successfully');
      handleClose();
    } catch (error) {
      console.error(`Error denying ${isReport ? 'report' : 'dispute'}:`, error);
      toast.error(
        error.response?.data?.detail || `Failed to deny ${isReport ? 'report' : 'dispute'}`
      );
    }
  };

  // Content based on user role and type (report vs dispute)
  const getModalTitle = () => {
    if (isReport) {
      return userRole === 'teacher' ? 'Deny Instructor Report' : 'Deny Learner Report';
    }
    return userRole === 'teacher' ? 'Deny Instructor Dispute' : 'Deny Learner Dispute';
  };

  const getModalContent = () => {
    if (isReport) {
      if (userRole === 'teacher') {
        return 'You are about to deny this report filed by the instructor. This means you consider the report invalid and no action will be taken.';
      } else {
        return 'You are about to deny this report filed by the learner. This means you consider the report invalid and no action will be taken.';
      }
    }
    if (userRole === 'teacher') {
      return 'You are about to deny this dispute filed by the instructor. This means you consider the dispute invalid and no action will be taken.';
    } else {
      return 'You are about to deny this dispute filed by the learner. This means you consider the dispute invalid and no refund will be issued.';
    }
  };

  const getNoteText = () => {
    if (isReport) {
      return 'Note: Denying a report means you have reviewed the case and determined that the complaint is not valid.';
    }
    return 'Note: Denying a dispute means you have reviewed the case and determined that the complaint is not valid.';
  };

  const getButtonText = () => {
    return isReport ? 'Deny Report' : 'Deny Dispute';
  };

  return (
    <Modal
      open={true}
      // onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-6 py-4 border-b border-[#D5DEE3]">
          <Typography className="dispute-cancel-dispute-text">{getModalTitle()}</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center text-center gap-4 px-[11%] py-4 border-b border-[#D5DEE3]">
          <img src={rejectIcon} alt="reject" />
          <Typography className="dispute-cancel-dispute-text">{getModalContent()}</Typography>
          <Typography className="dispute-note-text">{getNoteText()}</Typography>
        </Box>
        <Box className="flex items-center justify-center gap-4 px-6 py-4">
          <button className="dispute-cancel-application-button" onClick={handleClose}>
            Cancel
          </button>
          <button className="dispute-reject-application-button" onClick={handleReject}>
            {getButtonText()}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisputeRejectModal;
